"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOBILE_EXTERNAL_VIEWER_FILETYPES = void 0;
exports.MOBILE_EXTERNAL_VIEWER_FILETYPES = [
    'PDF',
    'PRESENTATION',
    'SPREADSHEET',
    'TEXT'
];
